import { graphql } from '../../generated';

export const GetPage = graphql(`
  query GetPageBySlug($uri: ID!) {
    kiaPage(id: $uri, idType: URI) {
      databaseId
      pagebuilder {
        blocks {
          ...PageBuilderBlocks
        }
      }
    }
  }
`);

export const GetModule = graphql(`
  query GetModuleBySlug($uri: ID!) {
    kiaModule(id: $uri, idType: URI) {
      databaseId
      pagebuilder {
        blocks {
          ...ModuleBuilderBlocks
        }
      }
    }
  }
`);
